import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from 'classnames';
import React, { useContext, useMemo } from 'react';
import { Feedback } from './Feedback';
import { FormCheckInput } from './FormCheckInput';
import { FormCheckLabel } from './FormCheckLabel';
import { FormContext } from './FormContext';
// eslint-disable-next-line
export const FormCheck = /*#__PURE__*/ React.forwardRef(({ id, inline = false, disabled = false, isSuccess = false, isError = false, isWarning = false, feedbackTooltip = false, feedback, className, style, title = '', type = 'checkbox', label, children, componentClass = 'input', ...props }, ref)=>{
    const bsPrefix = 'form-check';
    const { controlId, validationState } = useContext(FormContext);
    const innerFormContext = useMemo(()=>({
            controlId: id || controlId
        }), [
        controlId,
        id
    ]);
    const hasLabel = label !== null && label !== undefined && label !== false && !children;
    const success = validationState === 'success' || isSuccess;
    const error = validationState === 'error' || isError;
    const warning = validationState === 'warning' || isWarning;
    const input = /*#__PURE__*/ _jsx(FormCheckInput, {
        ...props,
        type: type === 'switch' ? 'checkbox' : type,
        ref: ref,
        isSuccess: success,
        isError: error,
        isWarning: warning,
        isStatic: !hasLabel,
        disabled: disabled,
        componentClass: componentClass
    });
    return /*#__PURE__*/ _jsx(FormContext.Provider, {
        value: innerFormContext,
        children: /*#__PURE__*/ _jsx("div", {
            style: style,
            className: classNames(className, bsPrefix, inline && `${bsPrefix}-inline`, type === 'switch' && 'form-switch'),
            children: children || /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    input,
                    hasLabel && /*#__PURE__*/ _jsx(FormCheckLabel, {
                        title: title,
                        children: label
                    }),
                    (success || warning || error) && /*#__PURE__*/ _jsx(Feedback, {
                        type: success ? 'success' : warning ? 'warning' : error ? 'error' : undefined,
                        tooltip: feedbackTooltip,
                        children: feedback
                    })
                ]
            })
        })
    });
});
FormCheck.displayName = 'FormCheck';
FormCheck.Input = FormCheckInput;
FormCheck.Label = FormCheckLabel;
